// PCヘッダーの固定 - 下スクロールで消えて上スクロールで出現
$(function(){
  var startPos = 0,winScrollTop = 0;
  $(window).on('scroll',function(){
      winScrollTop = $(this).scrollTop();

      // ページロード時はヘッダーの高さを取得するためrelativeの指定。スクロール後fixed適用。
      if (winScrollTop >= startPos) {
          if(winScrollTop >= 1){
              $('.header-fixed').addClass('fixed');
          }
      }
      // ヘッダーの表示・非表示
      if (winScrollTop > startPos) {
          if(winScrollTop > 200){
              $('.header-fixed').addClass('header-hide');
          }
      } else if (winScrollTop < startPos) {
          $('.header-fixed').removeClass('header-hide');
      }
      startPos = winScrollTop;
  });
});

// ヘッダー固定の場合にコンテンツ幅が「ヘッダー幅 > コンテンツ幅」の場合の横スクロール処理
$(function(){
  $(window).on("scroll", function(){
      $(".header-fixed").css("left", -$(window).scrollLeft());
  });
});

// ヘッダーがfixedになるとヘッダーの高さ分コンテンツが見えなくなるため、
// PC閲覧(769px以上)の場合にロード時にヘッダー領域の高さを設定。
$(function(){
  if(window.innerWidth >= 769){
    var headerHeight = $('.header-fixed').height();
    $('#header-pc').css('height',headerHeight);
  }
});